import { ICommit } from "@/apps/merchant3/shared-models/ICommit";
import { SideBarState } from "@/apps/merchant3/store/ui/mutations";

const actions = {
  setInConsoleSidebarState: (
    { commit }: ICommit,
    payload: Partial<SideBarState>
  ): void => {
    commit("SET_IN_CONSOLE_MESSAGES_SIDEBAR_STATE", payload);
  },
};

export default actions;
